import React from 'react';

import PropTypes from 'prop-types';

const HighlightOffer = ({ title = '' }) => {
  return (
    <svg width="59" height="71" viewBox="0 0 59 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{title || ''}</title>
      <rect width="59" height="71" rx="4" fill="#FEFAEC" />
      <g filter="url(#filter0_d_2715_7265)">
        <path
          d="M8 34.1089C8 31.2873 10.2873 29 13.1089 29L26.823 29C27.5284 29 28.1002 29.5718 28.1002 30.2772V35.9494C28.1002 38.772 25.812 41.0601 22.9895 41.0601H13.1107C10.2882 41.0601 8 38.772 8 35.9494V34.1089Z"
          fill="white"
        />

        <circle cx="13.321" cy="34.991" r="1.48804" fill="#CED2D8" />
        <circle cx="17.7854" cy="34.991" r="1.48804" fill="#CED2D8" />
        <circle cx="22.2493" cy="34.991" r="1.48804" fill="#CED2D8" />
      </g>
      <rect
        width="15.2143"
        height="15.2143"
        rx="7.60714"
        transform="matrix(-1 0 0 1 43.2134 7)"
        fill="#F7CE46"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5081 12.3888C37.5922 12.3888 37.6728 12.4222 37.7322 12.4816C37.7917 12.5411 37.8251 12.6217 37.8251 12.7058V17.1433C37.8251 17.2273 37.7917 17.308 37.7322 17.3674C37.6728 17.4268 37.5922 17.4602 37.5081 17.4602H33.7045C33.6205 17.4602 33.5398 17.4268 33.4804 17.3674C33.421 17.308 33.3876 17.2273 33.3876 17.1433V12.7058C33.3876 12.6217 33.421 12.5411 33.4804 12.4816C33.5398 12.4222 33.6205 12.3888 33.7045 12.3888H34.3384C34.5135 12.3888 34.6554 12.2469 34.6554 12.0718C34.6554 11.8968 34.5135 11.7549 34.3384 11.7549H33.7045C33.4523 11.7549 33.2105 11.8551 33.0321 12.0334C32.8538 12.2117 32.7536 12.4536 32.7536 12.7058V17.1433C32.7536 17.3955 32.8538 17.6373 33.0321 17.8157C33.2105 17.994 33.4523 18.0942 33.7045 18.0942H37.5081C37.7603 18.0942 38.0021 17.994 38.1805 17.8157C38.3588 17.6373 38.459 17.3955 38.459 17.1433V12.7058C38.459 12.4536 38.3588 12.2117 38.1805 12.0334C38.0021 11.8551 37.7603 11.7549 37.5081 11.7549H36.8742C36.6991 11.7549 36.5572 11.8968 36.5572 12.0718C36.5572 12.2469 36.6991 12.3888 36.8742 12.3888H37.5081Z"
        fill="white"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.1909 11.755C37.1909 11.4049 36.9071 11.1211 36.557 11.1211H34.6552C34.3051 11.1211 34.0213 11.4049 34.0213 11.755V12.389C34.0213 12.7391 34.3051 13.0229 34.6552 13.0229H36.557C36.9071 13.0229 37.1909 12.7391 37.1909 12.389V11.755ZM34.6552 11.755H36.557V12.389H34.6552V11.755Z"
        fill="white"
      />

      <rect
        width="15.2143"
        height="15.2143"
        rx="7.60714"
        transform="matrix(-1 0 0 1 53.2144 27)"
        fill="#FF8029"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.6383 31.4375H48.7768C48.9518 31.4375 49.0938 31.5794 49.0938 31.7545V33.6826V35.6108V37.539C49.0938 37.7141 48.9518 37.856 48.7768 37.856H42.4997C42.3247 37.856 42.1828 37.7141 42.1828 37.539V35.6108V33.6826V31.7545C42.1828 31.5794 42.3247 31.4375 42.4997 31.4375H45.6383ZM42.8167 33.3657H44.069H45.3213V32.0714H42.8167V33.3657ZM42.8167 33.9996V35.2938H43.752V33.9996H42.8167ZM42.8167 35.9278H45.3213V37.222H42.8167V35.9278ZM45.9552 37.222V35.9278H48.4598V37.222H45.9552ZM48.4598 35.2938H47.5245V33.9996H48.4598V35.2938ZM48.4598 33.3657H47.2075H45.9552V32.0714H48.4598V33.3657ZM44.386 33.9996V35.2938H45.6383H46.8906V33.9996H45.642L45.6383 33.9996L45.6346 33.9996H44.386Z"
        fill="white"
      />

      <rect
        width="15.2143"
        height="15.2143"
        rx="7.60714"
        transform="matrix(1 0 0 -1 28 63.2139)"
        fill="#7783FF"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8259 58.142C37.8259 57.967 37.684 57.8251 37.5089 57.8251H35.7534C35.3188 57.8251 34.8843 57.6118 34.5518 57.2002C34.2179 56.7868 34.0223 56.2141 34.0223 55.6063C34.0223 54.9985 34.2179 54.4259 34.5518 54.0124C34.8843 53.6008 35.3188 53.3876 35.7534 53.3876H37.5089C37.684 53.3876 37.8259 53.2456 37.8259 53.0706C37.8259 52.8955 37.684 52.7536 37.5089 52.7536H35.7534C35.1017 52.7536 34.4944 53.0746 34.0586 53.6141C33.6244 54.1518 33.3884 54.869 33.3884 55.6063C33.3884 56.3436 33.6244 57.0608 34.0586 57.5985C34.4944 58.138 35.1017 58.459 35.7534 58.459H37.5089C37.684 58.459 37.8259 58.3171 37.8259 58.142Z"
        fill="white"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4375 56.2402C32.4375 56.4153 32.5794 56.5572 32.7545 56.5572H36.558C36.7331 56.5572 36.875 56.4153 36.875 56.2402C36.875 56.0652 36.7331 55.9233 36.558 55.9233H32.7545C32.5794 55.9233 32.4375 56.0652 32.4375 56.2402Z"
        fill="white"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4375 54.9724C32.4375 55.1474 32.5794 55.2893 32.7545 55.2893H36.558C36.7331 55.2893 36.875 55.1474 36.875 54.9724C36.875 54.7973 36.7331 54.6554 36.558 54.6554H32.7545C32.5794 54.6554 32.4375 54.7973 32.4375 54.9724Z"
        fill="white"
      />

      <defs>
        <filter
          id="filter0_d_2715_7265"
          x="0"
          y="23"
          width="36.1001"
          height="28.0605"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />

          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0901961 0 0 0 0 0.129412 0 0 0 0 0.203922 0 0 0 0.15 0"
          />

          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2715_7265" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2715_7265"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

HighlightOffer.propTypes = {
  title: PropTypes.string,
};

export default HighlightOffer;
